import { render } from "./PropsSBP.vue?vue&type=template&id=55808cd3"
import script from "./PropsSBP.vue?vue&type=script&lang=js"
export * from "./PropsSBP.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__